// Librairies
import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { ModelService } from 'src/app/services/api/models/model.service';
import { PlanningService } from 'src/app/services/api/plannings/planning.service';
import { UnitService } from 'src/app/services/api/units/unit.service';

// Interfaces
import { Model } from 'src/app/interfaces/api/model';
import { Planning, PostPlanning, PutPlanning } from 'src/app/interfaces/api/planning';
import { Unit } from 'src/app/interfaces/api/unit';

// Components
import { ButtonComponent } from 'ui-library';

@Component({
  selector: 'app-planning-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    TranslateModule,
    ButtonComponent
  ],
  templateUrl: './planning-dialog.component.html',
  styleUrls: ['./planning-dialog.component.scss']
})

export class PlanningDialogComponent implements OnInit, OnDestroy {
  // Services
  public readonly data: any = inject(MAT_DIALOG_DATA);
  public readonly planningService: PlanningService = inject(PlanningService);
  public readonly modelService: ModelService = inject(ModelService);
  public readonly unitService: UnitService = inject(UnitService);
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly dialog: MatDialog = inject(MatDialog);

  // Variables
  planning: Partial<Planning> = {
    name: "",
  };
  models: Model[] = [];
  units: Unit[] = [];
  destroy$ = new Subject<void>();

  constructor() {
    this.modelService.getModels().pipe(takeUntil(this.destroy$)).subscribe((res: Model[]) => {
      this.models = res;
    })

    this.unitService.getUnits().pipe(takeUntil(this.destroy$)).subscribe((res: Unit[]) => {
      this.units = res;
    })
  }

  ngOnInit() {
      this.planning = this.data.planning;

    if (this.planning.model && typeof this.planning.model === 'object' && 'id' in this.planning.model)
      this.planning.model = this.planning.model.id

    if (this.planning.unit && typeof this.planning.unit === 'object' && 'id' in this.planning.unit)
      this.planning.unit = this.planning.unit.id

    if (this.data.duplicate) {
      this.planning.name = this.translate.instant("form.copy_of") + " " + this.planning.name
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  savePlanning() {
    if (!this.planning.name) return;

    if (this.data.duplicate) {
      this.planningService.duplicatePlanning(this.planning as PostPlanning).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.dialog.closeAll();
      }, (err: unknown) => console.error(err))
    } else if (this.planning.id) {
      this.planningService.updatePlanning(this.planning as PutPlanning).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.dialog.closeAll();
      }, (err: unknown) => console.error(err))
    } else {
      this.planningService.addPlanning(this.planning as PostPlanning).pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.dialog.closeAll();
      }, (err: unknown) => console.error(err))
    }
  }

  close() {
    this.dialog.closeAll();
  }
}
